import { render, staticRenderFns } from "./AppDashboardPie.vue?vue&type=template&id=c0533cde&"
import script from "./AppDashboardPie.vue?vue&type=script&lang=js&"
export * from "./AppDashboardPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports